import environmentFlags from '@peloton/env/environmentFlags';
import { maybeHostname } from '@peloton/internationalize/models/locale';
import { FeatureEnvironments } from './enums';

export const getCurrentEnvironment = (): FeatureEnvironments => {
  if (typeof window === 'undefined') {
    return FeatureEnvironments.Dev;
  }

  const hostname = maybeHostname();
  // The environment flags are based on the hostname. The auth app appears as "auth".
  const envFlags = environmentFlags('auth')(hostname);

  if (envFlags.isProd || envFlags.isProdTest) {
    return FeatureEnvironments.Production;
  }

  if (envFlags.isUat || envFlags.isStaging || envFlags.isStageN) {
    return FeatureEnvironments.UAT;
  }

  return FeatureEnvironments.Dev;
};

export const isDev = (): boolean => getCurrentEnvironment() == FeatureEnvironments.Dev;
export const isUat = (): boolean => getCurrentEnvironment() == FeatureEnvironments.UAT;
export const isProd = (): boolean =>
  getCurrentEnvironment() == FeatureEnvironments.Production;
